import { render } from "./S148676.vue?vue&type=template&id=b5a2cbf8"
const script = {}
script.render = render

export default script